import {Injectable} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {FabricService} from 'src/app/services/fabric/fabric.service';

const SERVICE_NAME = 'mgmt-user-resources';

@Injectable({
  providedIn: 'root'
})
export class UserService {
  
  private refreshBookmarkSubject = new Subject<void>();
  bookmarkRefresh$ = this.refreshBookmarkSubject.asObservable();

  constructor(private fabricService: FabricService) {
  }

  notifyBookmarkRefresh() {
    this.refreshBookmarkSubject.next();
  }

  getBookmarks(userId?: string): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'get_user-profile_mgmt_user-profile_bookmark_userid', {userId});
  }
  
  addBookmark(bookmarkDetails?: string): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_user-profile_mgmt_user-profile_bookmark', bookmarkDetails);
  }

  deleteBookmark(bookmarkId?: string): Observable<any> {
      return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'delete_user-profile_mgmt_user-profile_bookmark_bookmarkid', {bookmarkId});
  }
}
